import { useCmsPage } from "@/hooks/useCms";
import LoadingScreen from "@/components/LoadingScreen";
import SoftwareModulesPage from "@/components/cms/SoftwareModulesPage";

export default function ModulesPage() {
  const { page, loading } = useCmsPage("modules");

  if (loading) return <LoadingScreen />;
  if (!page) return null;

  return <SoftwareModulesPage page={page} />;
}